import {useEffect} from 'react';
import {usePrevious} from '../../../hooks/usePrevious';
import {useContentRequirementsContext} from '../ContentRequirementsProvider';

export const useRestrictionLiftedObserver = (onRestrictionLifted: () => void, onItemChanged: () => void) => {
  const { fulfilled, itemId } = useContentRequirementsContext();

  const wasRestricted = usePrevious(fulfilled === false);
  const previousItemId = usePrevious(itemId);
  useEffect(() => {
    const isSameItem = itemId === previousItemId;
    const wasUnlocked = wasRestricted && fulfilled;
    if (isSameItem && wasUnlocked) {
      onRestrictionLifted();
    }
  }, [fulfilled, itemId, onRestrictionLifted, previousItemId, wasRestricted]);
  useEffect(() => {
    if (itemId !== previousItemId) {
      onItemChanged();
    }
  }, [previousItemId, itemId, onItemChanged]);
};
